
export const oldURLDictionary = {
  "wportal.gco.global":"dportaloccident.gco.global",
  "localhost.gco.global":"dportaloccident.gco.global",
  "dportal.gco.global":"dportaloccident.gco.global",

  "dportalsco.gco.global":"dportaloccident.gco.global",
  "portalsco.gco.global":"portaloccident.gco.global",
  "dportalcatalanaoccidente.gco.global":"dportaloccident.gco.global",
  "portalcatalanaoccidente.gco.global":"portaloccident.gco.global",

  "dportalsb.gco.global":"dportaloccident.gco.global",
  "portalsb.gco.global":"portaloccident.gco.global",
  "dportalsegurosbilbao.gco.global":"dportaloccident.gco.global",
  "portalsegurosbilbao.gco.global":"portaloccident.gco.global",

  "dportalpu.gco.global":"dportaloccident.gco.global",
  "portalpu.gco.global":"portaloccident.gco.global",
  "dportalplusultra.gco.global":"dportaloccident.gco.global",
  "portalplusultra.gco.global":"portaloccident.gco.global",

  "dportalnh.gco.global":"dportalnortehispanaadm.gco.global",
  "portalnh.gco.global":"portalnortehispanaadm.gco.global",
  "dportalnortehispana.gco.global":"dportalnortehispanaadm.gco.global",
  "portalnortehispana.gco.global":"portalnortehispanaadm.gco.global",
                
  "dportalpre.gco.global":"dportalprepersaadm.gco.global",
  "portalpre.gco.global":"portalprepersaadm.gco.global",
  "dportalprepersa.gco.global":"dportalprepersaadm.gco.global",
  "portalprepersa.gco.global":"portalprepersaadm.gco.global",

  "dportaltec.gco.global":"dportalaieadm.gco.global",
  "portaltec.gco.global":"portalaieadm.gco.global",
  "dportalaie.gco.global":"dportalaieadm.gco.global",
  "portalaie.gco.global":"portalaieadm.gco.global",
                                    
  "wgestiona.gco.global" : "dgestiona.gco.global",
  "dgestionanuevo.gco.global" : "dgestiona.gco.global",
  "gestionanuevo.gco.global" :  "gestiona.gco.global",

  "dgestiona.gco.global" : "dgestionaold.gco.global",
  "gestiona.gco.global" : "gestionaold.gco.global"

}
